const { baseColors } = require("@Constants/baseStyles")

const handleSetColor = (slider) => {
    switch (slider) {
        case 5:
            return "green"

        case 4:
            return "yellow"

        case 3:
            return "orange"

        case 2:
            return "red"

        default:
            return "purple"
    }
}

export { handleSetColor }
